import { CreditBureauEvent } from '../../../constants';

export enum CreditBureauPrivateWebsocketEvent {
  IndividualCreditEnquiryCompleted = CreditBureauEvent.IndividualCreditEnquiryCompleted,
}
